module.exports = __webpack_public_path__ + "static/media/icon_voicebot.126ca75e.svg";